import { UnitCompatibilityVerdict } from 'helpers/unitCompatibility';
import { ERROR_TOAST_TIMEOUT } from 'components/ToastContainer/toastManager';

export interface UnitCompatibilityError {
  title: string;
  content: string;
}

type RefusalVerdict = Exclude<UnitCompatibilityVerdict, 'ok'>;

interface ToastLike {
  error: (
    title: string,
    options: { content: string; supportButton: boolean; timeout: number }
  ) => void;
}

export const UNIT_COMPATIBILITY_ERRORS: Record<
  RefusalVerdict,
  UnitCompatibilityError
> = {
  'withdrawn-unit': {
    title: 'Invalid unit of measure',
    content:
      'The current unit of measure selection is no longer accepted. Please select another option from the list to save this product.'
  },
  'density-required': {
    title: 'Selected units require density',
    content:
      "The units of measure you've selected cannot be converted without a defined density. Add a density value or select a different unit of measure."
  },
  incompatible: {
    title: 'Incompatible units of measure',
    content:
      'Standard Unit and List Price need to use compatible units. Pair time-based or area-based units to save this product.'
  }
};

export const showUnitCompatibilityError = (
  toast: ToastLike,
  verdict: UnitCompatibilityVerdict
): boolean => {
  if (verdict === 'ok') return false;

  const { title, content } = UNIT_COMPATIBILITY_ERRORS[verdict];
  toast.error(title, {
    content,
    supportButton: true,
    timeout: ERROR_TOAST_TIMEOUT
  });
  return true;
};
